import BaseDocument from './BaseDocument';

class UserExposures extends BaseDocument {
}

export default UserExposures;
